import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=ebe61fb6&scoped=true&"
import script from "./grid-item.vue?vue&type=script&lang=js&"
export * from "./grid-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe61fb6",
  null
  
)

export default component.exports